import React from "react";
import "./iFrameText.scss";
const IFrameText = ({ text, height, classNameParam }) => {
    return (
        <div className={`iFrameText ${classNameParam}`} style={{ height: height }}>
            {text}
        </div>
    );
};

export default IFrameText;
